import { Cookies } from 'quasar';
import tokenDecode from 'jwt-decode';

interface Token {
  email: string;
  // 'cognito:username': string;
  // 'cognito:groups': string[];
  'custom:groups': string;
}

let $cookies: Cookies;

const AUTH_TOKEN_NAME = process.env.WS_AUTH_TOKEN_NAME as string;

export function setCookies(cookies: Cookies) {
  $cookies = cookies;
}

export function hasToken() {
  // process.env.DEBUGGING && console.info(`Check token "${AUTH_TOKEN_NAME}"`);
  // console.log('token', $cookies.has(COOKIE_AUTH_TOKEN), getToken());
  return $cookies.has(AUTH_TOKEN_NAME);
}

export function getTokenData() {
  // process.env.DEBUGGING && console.info(`Read token "${AUTH_TOKEN_NAME}"`);

  const token = $cookies.get(AUTH_TOKEN_NAME);
  if (!token) {
    throw Error('Token is empty or not found');
  }

  return tokenDecode<Token>(token);
}

export function removeToken(appHost: string) {
  const domain = appHost.substring(appHost.indexOf('.'));
  const props = { path: '/', domain, sameSite: 'None', other: 'Max-Age: 0' };

  process.env.DEBUGGING &&
    console.info(`Remove token "${AUTH_TOKEN_NAME}":`, props);

  $cookies.remove(AUTH_TOKEN_NAME, props);
  document.cookie = `qaToken=; SameSite=None; Secure; Domain=${domain}; Path=/; Max-Age=0`;
}
